import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider--left-2",
  "use": "icon-slider--left-2-usage",
  "viewBox": "0 0 11 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 10\" id=\"icon-slider--left-2\"><path d=\"m4.29 9.51.96-.93-2.864-3.15h8.55V4.08h-8.55L5.25.93 4.29 0 0 4.755 4.29 9.51Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol